import { useCallback, useEffect, useState } from 'react';

const useTimer = (props?: { initialCount: number }) => {
    const { initialCount = 120 } = props;

    const [seconds, setSeconds] = useState(initialCount);
    const [disabled, setDisabled] = useState(true);

    useEffect(() => {
        let interval = null;

        if (disabled && seconds > 0) {
            interval = setInterval(() => {
                setSeconds((seconds) => seconds - 1);
            }, 1000);
        } else if (seconds === 0) {
            clearInterval(interval);
            setDisabled(false);
        }

        return () => clearInterval(interval);
    }, [disabled, seconds]);

    const reset = useCallback(() => {
        setSeconds(initialCount);
        setDisabled(true);
    }, [initialCount]);

    return {
        seconds,
        disabled,
        reset,
    };
};

export default useTimer;
